// extracted by mini-css-extract-plugin
export default {"controlsPanelGrid":"ControlsPanelGrid_controlsPanelGrid__8LrXa"};